import cn from 'classnames';
import { VStack } from '@direct-frontend/components';
import zoomUpIconSource from './assets/geoLocation.svg';
import styles from './GeoLocationControl.module.css';

interface GeoLocationControlProps {
    onGeolocatePosition: () => void;
    className?: string;
}

export const GeoLocationControl = (props: GeoLocationControlProps) => {
    const { onGeolocatePosition, className } = props;

    return (
        <VStack className={cn(className, styles.container)}>
            <button className={styles.geoButton} onClick={onGeolocatePosition}>
                <img width="24" src={zoomUpIconSource} alt="Мое местоположение" draggable={false} />
            </button>
        </VStack>
    );
};
